import React, {useEffect, useRef, useState} from 'react'
import {Link, useNavigate, useParams} from 'react-router-dom'
import {
  ModeleClient,
  modeleClientDemandeInitValues,
  modeleClientInitValues,
  ModeleClientOtherData,
  modeleClientOtherDataInitValues,
} from '../../../../components/Models'
import {createClient, getClient, getClientOtherData} from '../../../../components/requests'
import {DemandeForm} from '../Components/DemandeForm'
import {useLocation} from 'react-router'
import {Tooltip} from 'react-tooltip'
import {useFilAriane} from "../../../contexts/FilArianeContext";

type LocationState = {
  redirectToClientDemande: boolean
  demandeId: number | null
  loadingCLientInfo: boolean
  isFromClient: boolean
  contactedBy: string
  filters?: any
  fromTraitement: boolean
  choicedDemandeSource: boolean
  isClientSociety?: any
  defaultValueContact?: any
  transformedSource?: any
  contentCommunication?: any
  isDuplicate?: boolean
  radioValue?: any
  clientDemandeStatus?: any
}

const DemandClientCreate = (props) => {
  const navigate = useNavigate()
  let {clientId} = useParams()
  const location = useLocation()
  const state = location.state as LocationState
  const [immatValide, setImmatValide] = useState<boolean>(true)
  const clientDataRef = useRef<ModeleClient | null>(null)
  const [data, setData] = useState<ModeleClient>(modeleClientInitValues)
  const [loading, setLoading] = useState(true)
  const [isProspect, setIsProspect] = useState<boolean>(false)
  const [isProfessionnel, setIsProfessionnel] = useState<boolean>(false)
  const [otherData, setOtherData] = useState<ModeleClientOtherData>(modeleClientOtherDataInitValues)
  const [dataClient, setDataClient] = useState<any>([])
  const [dataClientOther, setDataClientOther] = useState<any>([])
  const [loadingDataCLient, setLoadingDataCLient] = useState(false)
  const [isConfirmEdit, setIsConfirmEdit] = useState(false)
  const [idClient, setIdClient] = useState<any>(clientId)
  const [radioValueData, setRadioValue] = useState<string | null | undefined>(state?.radioValue)
  const [contentCommunicationData, setContentCommunication] = useState<string | null | undefined>(
    state?.contentCommunication
  )
  const {setEtape, setPanierAriane, setDemandeAriane} = useFilAriane()

  const submitForm = async (fieldsToUpdate: Partial<ModeleClient>, callback): Promise<void> => {
    const updatedData = Object.assign({...modeleClientInitValues}, fieldsToUpdate)

    try {
      const clientRequest = await createClient(updatedData)
      if (clientRequest?.status === 200) {
        if (clientRequest?.data?.id !== undefined && clientRequest?.data?.id !== null) {
          navigate(`/vente/clients/${clientRequest?.data?.id}/afficher`)
        }
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      callback()
    }
  }

  useEffect(() => {
    setEtape('NOUVE')
    setPanierAriane([])
    setDemandeAriane(null)
  }, []);

  // Close modal when navigating to "demande/createClient"
  useEffect(() => {
    const closeModalIfOnCreateClient = () => {
      if (window.location.pathname === '/demandes/create/:id') {
        // Select all modal-backdrop elements
        const backdrops = document.querySelector('.modal')
        if (backdrops) {
          backdrops.remove()
        }
      }
    }
    closeModalIfOnCreateClient()
  }, [window.location.pathname])

  const handleImmatValide = () => {
    setImmatValide(false)
  }

  const handleUpdateClientData = (clientId, radioValue: any = null, contentCommunication: any = null) => {
    setIsConfirmEdit(true)
    clientDataRef.current = null
    setIdClient(clientId)
    if (radioValue) setRadioValue(radioValue)
    if (contentCommunication) setContentCommunication(contentCommunication)
    // Changement de l'id du client dans l'url
    if (state?.demandeId) {
      navigate(`/demandes/${clientId}/edit/${state?.demandeId}`, {
        replace: true,
        state: state as LocationState
      })
    } else {
      navigate(`/demandes/create/${clientId}`, {
        replace: true,
        state: state as LocationState
      })
    }
  }

  // Récupération des données client
  const getClientData = () => {
    setLoadingDataCLient(true)
    if (clientDataRef.current !== null) {
      if (clientDataRef.current.professionnel) setIsProfessionnel(true)
      setData(clientDataRef.current)
      setLoading(false)
      return
    }

    getClient(idClient).then((res) => {
      if (res?.status === 200 && res?.data?.id) {
        setLoadingDataCLient(false)
        const updatedData = {...res.data}
        updatedData.idPays = updatedData.pays?.id
        clientDataRef.current = updatedData
        setData(updatedData)
        // Données clients à passer en state
        setDataClient(res?.data)
        if (!window.location.pathname.includes('create')) {
          getClientDataOthers()
        }
        if (updatedData.typeClient === 'PROSPECT') {
          setIsProspect(true)
        }
        if (updatedData.professionnel) {
          setIsProfessionnel(true)
        }
      } else {
        setLoadingDataCLient(false)
        navigate('/vente/clients/liste')
      }
    })
    // if (!window.location.pathname.includes('create')) {
    //   getClientDataOthers()
    // }
  }

  // Récupération des données clients supplémentaires
  const getClientDataOthers = () => {
    getClientOtherData(idClient, state?.demandeId).then((clientRequest) => {
      if (clientRequest?.status === 200) {
        const updatedData = Object.assign({...data}, clientRequest?.data)
        setOtherData({...updatedData})
        setDataClientOther(clientRequest?.data)
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    getClientData()
  }, [idClient])

  // Gestion de redirection pour le bouton retour
  const handleToPreviousPage = () => {
    if (state?.isFromClient) {
      if (state?.fromTraitement) {
        return `/demandes/${idClient}/traitement/${state?.demandeId}`
      } else {
        return `/vente/clients/${idClient}/afficher/demandClient`
      }
    } else {
      if (state?.fromTraitement) {
        return `/demandes/${idClient}/traitement/${state?.demandeId}`
      }
      if (state?.isFromClient == undefined) {
        return '/demandes/liste'
      }
      if (state?.redirectToClientDemande) {
        return '/demandes/liste'
      }
    }
    // FallBack
    return '/'
  }

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mb-3'>
        <Link
          to={handleToPreviousPage()}
          state={{
            filters: state?.filters,
            redirectToClientDemande: state?.redirectToClientDemande,
            fromTraitement: state?.fromTraitement,
            isFromClient: state?.isFromClient,
          }}
          data-tooltip-id='tooltip'
          data-tooltip-content='Revenir en arrière'
          data-tooltip-place='right'
          className='btn btn-light'
        >
          <i className='ki-duotone ki-arrow-left fs-3'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
          Retour
        </Link>
      </div>

      {/*<h1 className='text-gray-500'>{state.demandeId ? 'Modifier' : 'Créer'} une demande</h1>*/}
      <div>
        {/* Récupération de l'id du client qu'on vient de créer et redirection vers "DemandeAdd" après avoir effectué l'enregistrement*/}
        {!(state.demandeId && !immatValide) ? (
          <DemandeForm
            idClient={idClient}
            isProfessionnel={isProfessionnel}
            demandeId={state?.demandeId ?? null}
            data={modeleClientDemandeInitValues}
            submitForm={submitForm}
            redirectToClientDemande={state?.redirectToClientDemande ?? false}
            handleImmatValide={handleImmatValide}
            contactedBy={state?.contactedBy}
            dataClient={dataClient}
            dataClientOther={dataClientOther}
            immatValide={immatValide}
            loadingDataCLient={loadingDataCLient}
            setLoadingDataCLient={setLoadingDataCLient}
            filters={state?.filters}
            fromTraitement={state?.fromTraitement}
            isFromClient={state?.isFromClient}
            choicedDemandeSource={
              state?.isFromClient ? props.choicedDemandeSource : state?.choicedDemandeSource
            }
            isClientSocietyDemande={state?.isClientSociety}
            defaultValueContactDemande={state?.defaultValueContact}
            isDuplicateDemande={state?.isDuplicate}
            radioValueDemande={radioValueData}
            contentCommunicationDemande={contentCommunicationData}
            handleUpdateClientData={handleUpdateClientData}
            isConfirmEdit={isConfirmEdit}
            setIsConfirmEdit={setIsConfirmEdit}
            clientDemandeStatus={state?.clientDemandeStatus ?? ''}
          />
        ) : (
          <div className='border-top p-9 text-center'>
            Aucun résultat associé à l'immatriculation
          </div>
        )}
      </div>
      {/*Affichage du tooltip*/}
      <Tooltip id='add-tooltip' />
    </>
  )
}

export {DemandClientCreate}
